module.exports = __webpack_public_path__ + "media/images/subject_img/MARKETING-0f015bd007c6bc7421299e71ab03ee0b.jpg";